import style from "./ModalWrapper.module.scss";
import { HandySvg } from "handy-svg";
import { useEffect } from "react";
import ReactDOM from "react-dom";
import { bodyActiveScroll, bodyHiddenScroll } from "../../../../utils/bodyToggleHiddenScroll";

function ModalWrapper({ closeModal = () => {}, children }) {
	useEffect(() => {
		console.log(1);
		bodyHiddenScroll();

		return () => {
			bodyActiveScroll();
		};
	}, []);

	return ReactDOM.createPortal(
		<div className={style.overlay}>
			<div onClick={closeModal ? closeModal : () => {}} className={style.closeBack}></div>
			<div className={style.window}>
				{closeModal !== false && (
					<button onClick={closeModal} className={style.closeButton}>
						<HandySvg src={"/illustration_service/editor/close.svg"} width={20} height={20} />
					</button>
				)}
				{children}
			</div>
		</div>,
		document.getElementById("portal")
	);
}

export default ModalWrapper;
